import { vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9810305c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for", "disabled"]
const _hoisted_2 = ["id", "name", "value", "data-checked", "disabled"]
const _hoisted_3 = { class: "answer-text" }
const _hoisted_4 = { class: "select-outer-circle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioFilled = _resolveComponent("RadioFilled")!

  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(["answer-container", [{ selected: _ctx.isSelected, focused: _ctx.isFocused, 'disabled': _ctx.isReadOnly }, `label-${_ctx.id}` ]]),
    tabindex: "-1",
    for: _ctx.id,
    disabled: _ctx.isReadOnly
  }, [
    _withDirectives(_createElementVNode("input", {
      class: "hide",
      type: "radio",
      id: _ctx.id,
      name: _ctx.name,
      value: _ctx.index,
      "data-checked": _ctx.isSelected,
      disabled: _ctx.isReadOnly,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.radioModel) = $event)),
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleCheckbox && _ctx.toggleCheckbox(...args))),
      onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleCheckbox && _ctx.toggleCheckbox(...args))),
      onFocus: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.inputFocused && _ctx.inputFocused(...args))),
      onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.inputBlurred && _ctx.inputBlurred(...args)))
    }, null, 40, _hoisted_2), [
      [_vModelRadio, _ctx.radioModel]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_RadioFilled, { class: "select-inner" })
    ])
  ], 10, _hoisted_1))
}